import type { SearchCriteria, PartialSearchCriteria } from '../../model/types';

export interface ToCountryParams {
  toCountry?: number;
}

export function toCountry(criteria: SearchCriteria | PartialSearchCriteria): ToCountryParams {
  const { destination } = criteria;
  if (destination?.kind !== 'none' && destination?.country?.id) {
    return { toCountry: destination.country.id };
  }
  return {};
}
